
define('text!modules/audiences/pixels/templates/layout.html',[],function () { return '<div class="w-grid"></div>';});

